import { render } from "./GenerateCoverModal.vue?vue&type=template&id=4b196639&scoped=true"
import script from "./GenerateCoverModal.vue?vue&type=script&lang=js"
export * from "./GenerateCoverModal.vue?vue&type=script&lang=js"

import "./GenerateCoverModal.vue?vue&type=style&index=0&id=4b196639&scoped=true&lang=css"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b196639"]])

export default __exports__